import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  LinearProgress,
  TableHeader,
  TableContainer,
  NO_DATA_PLACEHOLDER,
} from '@occc-app/design-system';
import { TransactionPaymentInfo as PaymentInfo } from '@occc/graphql';

import { detailsPage as copy } from './transaction-details.copies';

type TransactionPaymentInfoProps = {
  paymentInfo: (PaymentInfo | null)[];
  loading?: boolean;
};

export const TransactionPaymentInfo = ({ paymentInfo, loading }: TransactionPaymentInfoProps) => (
  <TableContainer
    sx={(theme) => ({
      marginBottom: theme.spacing(1),
    })}
  >
    <TableHeader title={copy.paymentInfoSection.title} />
    {loading && <LinearProgress />}
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>Card Type</TableCell>
          <TableCell>Card PAN Print</TableCell>
          <TableCell>Host Auth Number</TableCell>
          <TableCell>Card Circuit</TableCell>
          <TableCell>Pre Auth Amount</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {paymentInfo &&
          paymentInfo.map((item, index) => (
            <TableRow key={index}>
              <TableCell>{item?.cardType || NO_DATA_PLACEHOLDER}</TableCell>
              <TableCell>{item?.cardPANPrint || NO_DATA_PLACEHOLDER}</TableCell>
              <TableCell>{item?.hostAuthNumber || NO_DATA_PLACEHOLDER}</TableCell>
              <TableCell>{item?.cardCircuit || NO_DATA_PLACEHOLDER}</TableCell>
              <TableCell>{item?.preAuthAmount || NO_DATA_PLACEHOLDER}</TableCell>
            </TableRow>
          ))}
      </TableBody>
    </Table>
  </TableContainer>
);
